import { render, staticRenderFns } from "./ChatMessageComponent.vue?vue&type=template&id=ab845406&scoped=true&"
import script from "./ChatMessageComponent.vue?vue&type=script&lang=ts&"
export * from "./ChatMessageComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessageComponent.vue?vue&type=style&index=0&id=ab845406&prod&lang=scss&scoped=true&"
import style1 from "./ChatMessageComponent.vue?vue&type=style&index=1&id=ab845406&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab845406",
  null
  
)

export default component.exports